import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { Pagination } from '../../models/pagination';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';
import { map, Observable } from 'rxjs';
import { UserProfileDto, UserProfileNoIdDto, UserProfileSimpleDto } from '../../models/user/user-profile-dto';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/profiles`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  getPaginatedResponse(pagination: Pagination<UserProfileSimpleDto>): PaginatedResponse<UserProfileSimpleDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  search(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<UserProfileSimpleDto>> {
    return this.http
      .get<PaginatedResponse<UserProfileSimpleDto>>(`${this.endpoint}${this.apiService.getQueryParams(paginatorFilters)}`)
      .pipe(map((items: Pagination<UserProfileSimpleDto>) => this.getPaginatedResponse(items)));
  }

  findAll(): Observable<UserProfileSimpleDto[]> {
    return this.http.get<UserProfileSimpleDto[]>(`${this.endpoint}/all`);
  }

  findById(userProfileId: number): Observable<UserProfileDto> {
    return this.http.get<UserProfileDto>(`${this.endpoint}/${userProfileId}`);
  }

  findByType(type: string): Observable<UserProfileDto[]> {
    return this.http.get<UserProfileDto[]>(`${this.endpoint}/type/${type}`);
  }

  create(data: UserProfileNoIdDto): Observable<UserProfileDto> {
    return this.http.post<UserProfileDto>(this.endpoint, data);
  }

  update(userProfileId: number, data: UserProfileNoIdDto): Observable<UserProfileDto> {
    return this.http.put<UserProfileDto>(`${this.endpoint}/${userProfileId}`, data);
  }
}
